import { IElementOffset } from '../types/calculator';

export const DEFAULT_ELEMENT_OFFSET: { field: IElementOffset; static: IElementOffset } = {
  field: {
    bottom: 16,
  },
  static: {
    bottom: 16,
  },
};
